import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { AppLanguage } from 'src/common/models/app-language';
import { Button } from 'antd';
import syltes from './SwitchLan.module.scss';
import LanguageWhiteIcon from '@public/images/Language_White.svg';
import LanguageBlackIcon from '@public/images/Language_Black.svg';

const SwitchLan = function ({ sm = false }) {
    const router = useRouter();
    const { t, i18n } = useTranslation();
    const changeTo = i18n.language === AppLanguage.zh_hk ? AppLanguage.en_us : AppLanguage.zh_hk;

    let btn = <></>;
    if (sm) {
        btn = (
            <div>
                <LanguageBlackIcon></LanguageBlackIcon>
            </div>
        );
    } else {
        const langTxt = t('Language');
        btn = (
            <div className={syltes['btn-content']}>
                <LanguageWhiteIcon></LanguageWhiteIcon>
                <span>{langTxt}</span>
            </div>
        );
    }

    return (
        <>
            <Link href={router.asPath} locale={changeTo}>
                <a className='hover:no-underline'>{btn}</a>
            </Link>
        </>
    );
};

export default SwitchLan;
